export default {
  schedule:{
    weekdays: {
      1: "Monday",
      2: "Tuesday",
      3: "Wednesday",
      4: "Thursday",
      5: "Friday",
      6: "Saturday",
      7: "Sunday"
    },
    weekdays: {
      1: "Mon.",
      2: "Tues.",
      3: "Wed.",
      4: "Thurs.",
      5: "Fri.",
      6: "Sat.",
      7: "Sun."
    },
    allShows: "<i class=\"fa fa-search\"></i> All Shows",
    calendar: "<i class=\"fa fa-calendar\"></i> Calendar",
  },
  shows: {
    backToShows: "Back to Schedule"
  }
}